import type { CreditCardListModel } from 'src/models/creditCard.models'

export const shouldCreateBalanceLockedBillPay = (
  isBillPay: boolean | undefined,
  selectedCreditCard: CreditCardListModel | undefined,
): boolean =>
  isBillPay === true &&
  selectedCreditCard?.features.balanceLockedEnabled === true
